import React, { useState } from 'react';
import { FormInputLabel, FormItemContainer, FormTextArea, } from '../StyledComponents';
import Grid from "@material-ui/core/Grid";

const TextAreaInput = ({
    value,
    name,
    label,
    placeholder,
    style,
    disabled,
    onChange,
    onPress,
    notRequired = false,
    readOnly = false,
    requiredColor = '#0061C6',
    maxLength = 140,
    showMaxLengthLabel = false,
    width,
    ...props
}) => {
    
    const [inputValue, setInputValue] = useState(value);
    const handleChange = (event) => {
        const newText = event.target.value;
        setInputValue(newText);
        onChange(newText);
    };
    
    return (
        <FormItemContainer  width={width}>
            <FormInputLabel>
                <label>
                    {label}{' '}
                    {!notRequired && <strong style={{color: requiredColor}}>*</strong>}
                </label>
            </FormInputLabel>
            <FormTextArea
                readOnly={readOnly}
                {...props}
                value={inputValue}
                placeholder={placeholder}
                onChange={(event) => handleChange(event)}
                onBlur={(event) => {
                    setInputValue(event.target.value.trim())
                    onChange(event.target.value.trim())
                }}
                maxLength={maxLength}
            />
            {
                !!showMaxLengthLabel &&
                <Grid item container flexDirection={'row'}>
                    <Grid item md={10}>
                        <>
                        </>
                    </Grid>
                    <Grid item md={2} style={{display: 'flex', justifyContent: 'flex-end', paddingRight: '10px'}}>
                        <FormInputLabel>{`${inputValue?.toString()?.length ?? 0}/${maxLength}`}</FormInputLabel>
                    </Grid>
                </Grid>
            }
        </FormItemContainer>
    );
};

export default TextAreaInput;
